export default "/images/minimize.svg?5862b48d9c4e55a14ffbced675a84345";